// extracted by mini-css-extract-plugin
export default {"messageContainer":"Messages_messageContainer__M8nPy","messageHeader":"Messages_messageHeader__xMJwd","messageList":"Messages_messageList__NvBz+","block":"Messages_block__Zm2NB"};